var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 28 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M10.286 19.167c-.631 0-1.143-.523-1.143-1.167v-3.5H2.28C1.02 14.5 0 13.46 0 12.172V2.828C0 1.542 1.02.5 2.28.5h16.011c1.26 0 2.28 1.04 2.28 2.328v9.344c0 1.286-1.02 2.328-2.28 2.328H11.43v2.333h12.12l-1.499-1.51c-.446-.455-.446-1.194 0-1.65.447-.455 1.17-.454 1.617.001l3.427 3.501c.235.242.337.583.337.826 0 .244-.089.582-.394.882-.093.091-3.372 3.442-3.372 3.442-.446.456-1.17.456-1.616 0-.446-.456-.446-1.194 0-1.65l1.478-1.508H10.286z",
    transform: "translate(-909 -645) translate(776 164) translate(133 481)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.286 12.167V7.5h-16v4.667h6.857V9.833c0-.644.512-1.166 1.143-1.166.63 0 1.143.522 1.143 1.166v2.334h6.857z",
    transform: "translate(-909 -645) translate(776 164) translate(133 481)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M18.286 2.833L2.286 2.833 2.286 4 18.286 4z",
    transform: "translate(-909 -645) translate(776 164) translate(133 481)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsRequest);
export default __webpack_public_path__ + "static/media/fs_request.a1a77f5a9027e9a0f1903982794bdb0c.svg";
export { ForwardRef as ReactComponent };